export default () => {
  let data = ["algorithm", "microservice"];

  return {
    data,
  };
};
